import React from 'react';

import imgCalendar from './assets/calendar.svg';
import imgCheck from './assets/check.svg';
import imgDanger from './assets/danger.svg';
import imgInfo from './assets/info.svg';
import imgMoney from './assets/money.svg';
import imgRocket from './assets/rocket.svg';
import imgRocketDanger from './assets/rocket-danger.svg';
import imgTime from './assets/time.svg';
import imgWpp from './assets/wpp.svg';

import {
  TuitionAlert,
  TuitionContent,
  TuitionDate,
  TuitionDebt,
  TuitionDivider,
  TuitionFooter,
  TuitionFooterWhatsapp,
  TuitionHeader,
  TuitionInit,
  TuitionLink,
  TuitionModality
} from './styled';
import Link from '@/presentation/reusables/Link';

interface IProps {
  profile: any;
  modalityOfStudy: any;
  enrolmentAppointment: any;
}

const ModalTuitionView = ({
  profile,
  modalityOfStudy,
  enrolmentAppointment
}: IProps) => {
  const formatPrice = (price: number) => {
    const intl = new Intl.NumberFormat('es-PE', {
      style: 'currency',
      currency: 'PEN'
    });

    return intl.format(price);
  };

  return (
    <>
      <TuitionContent data-testid="cmp-tuition-content">
        <TuitionHeader>
          <img
            src={
              enrolmentAppointment?.enrolmentEnabled
                ? imgRocket
                : imgRocketDanger
            }
            alt="rocket"
          />
          <p>
            ¡Hola
            <span>
              {profile?.firstName
                ? ` ${profile?.firstName?.toLowerCase()}`
                : ''}
            </span>
            ! tu turno de matrícula de <b>{enrolmentAppointment?.periodDesc}</b>{' '}
            es
          </p>
        </TuitionHeader>

        <TuitionDate>
          <div>
            <div>
              <div>
                <img src={imgCalendar} alt="calendar" />
              </div>
              <span>{enrolmentAppointment?.textDate}</span>
            </div>
            <div>
              <div>
                <img src={imgTime} alt="time" />
              </div>
              <span>{enrolmentAppointment?.textHour}.</span>
            </div>
            <p>
              Fecha fin de matrícula:{' '}
              <b>{enrolmentAppointment?.endEnrolmentText}</b>
            </p>
          </div>
        </TuitionDate>
        <TuitionModality>
          Modalidad actual: <b>{modalityOfStudy?.desc}</b>
        </TuitionModality>
        <TuitionAlert debt={enrolmentAppointment?.enrolmentEnabled}>
          <img
            src={enrolmentAppointment?.enrolmentEnabled ? imgCheck : imgDanger}
            alt="check"
          />
          <span>
            {enrolmentAppointment?.enrolmentEnabled
              ? 'Estás habilitado para matricularte'
              : 'No estás habilitado para matricularte.'}
          </span>
        </TuitionAlert>
        <TuitionDebt debt={enrolmentAppointment?.enrolmentEnabled}>
          {!enrolmentAppointment?.enrolmentEnabled && (
            <p>Habilita tu matrícula pagando lo siguiente:</p>
          )}
          {enrolmentAppointment?.enrolmentEnabled && (
            <div>
              <div>
                <img src={imgMoney} alt="money" />
                <span>No presentas deuda.</span>
              </div>
            </div>
          )}
          {!enrolmentAppointment?.enrolmentEnabled &&
            enrolmentAppointment?.enrolmentPayment?.assuranceAmount && (
              <div>
                <div>
                  <img src={imgMoney} alt="money" />
                  <span>
                    {enrolmentAppointment?.enrolmentPayment?.assuranceText}
                  </span>
                </div>
                <span>
                  {formatPrice(
                    enrolmentAppointment?.enrolmentPayment?.assuranceAmount
                  )}
                </span>
              </div>
            )}
          {!enrolmentAppointment?.enrolmentEnabled &&
            enrolmentAppointment?.enrolmentPayment?.enrolmentAmount && (
              <div>
                <div>
                  <img src={imgMoney} alt="money" />
                  <span>
                    {enrolmentAppointment?.enrolmentPayment?.enrolmentText}
                  </span>
                </div>
                <span>
                  {formatPrice(
                    enrolmentAppointment?.enrolmentPayment?.enrolmentAmount
                  )}
                </span>
              </div>
            )}
          {!enrolmentAppointment?.enrolmentEnabled &&
            enrolmentAppointment?.enrolmentPayment?.pendingFeeAmount && (
              <div>
                <div>
                  <img src={imgMoney} alt="money" />
                  <span>
                    {enrolmentAppointment?.enrolmentPayment?.pendingFeeText}
                  </span>
                </div>
                <span>
                  {formatPrice(
                    enrolmentAppointment?.enrolmentPayment?.pendingFeeAmount
                  )}
                </span>
              </div>
            )}
        </TuitionDebt>
        <TuitionDivider />
        <TuitionInit>
          <img src={imgInfo} alt="wpp" />
          <span>
            Inicio de clases: <b>{enrolmentAppointment?.startClassText}</b>
          </span>
        </TuitionInit>
        <TuitionLink
          href={enrolmentAppointment?.url}
          target="_blank"
          rel="noreferrer"
        >
          Más información
        </TuitionLink>
      </TuitionContent>
      <TuitionFooter>
        <TuitionFooterWhatsapp>
          <div>
            <img src={imgWpp} alt="wpp" />
          </div>
          <div>
            <span>Para resolver tus dudas comunícate con:</span>
            <Link
              linkType="external"
              url={`https://api.whatsapp.com/send?phone=51${enrolmentAppointment?.whatsapp}`}
              linkName="SAE Whatsapp"
            />
          </div>
        </TuitionFooterWhatsapp>
      </TuitionFooter>
    </>
  );
};

export default ModalTuitionView;
